import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import VendorShowWinState from "../../../vendor_core/src/states/VendorShowWinState";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import BangUp from "../../../vendor_core/core/src/utils/BangUp";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import { Tween } from "../../../vendor_core/core/src/Tween";
import PromiseHelpers from "../../../vendor_core/core/src/utils/PromiseHelpers";
import {
    Zoom,
    FadeOut
} from "../../../vendor_core/core/src/transitions/TransitionAnimations";
import BitmapTextField from "../../../vendor_core/core/src/views/components/BitmapTextField";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import { Ease } from "../../../vendor_core/core/src/Ease";
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import Utils from '../Utils';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';

export default class CRCShowWinState extends VendorShowWinState {

    public enter() {
        Utils.prepareTWScene();
        super.enter();
    }

    public displayWin(): void {
        const tumbleScene = ViewManager.getLayer("ThumbleWinCounter").getCurrentScene();
        const winTF = tumbleScene.sceneMoneyFields.get("tw_total");
        const twPlate = tumbleScene.groups.get("tw_plate");
        twPlate.visible = true;
        const cascade = SpinModel.cascades[SpinModel.cascadeIndex];

        if (cascade) {
            // Update tumble wins only when in cascade (not bonus trigger)
            const winBangUp = new BangUp();
            winBangUp.startBangup(
                cascade.tempWinAmount - cascade.winAmount,
                cascade.tempWinAmount,
                1.4,
                {},
                (val) => winTF.value = val
            );
            // CommandManager.execute(Commands.UPDATE_CASCADE_HISTORY);
        }

        SpinModel.tempWinAmount = cascade.accumulatedWin;

        const reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        const reels = Array.from(Array(reelGroup.reels.length).keys());
        const result = SpinModel.getFinalSymsForReels(reels);
        reelGroup.showFinalSymbols(result);

        CommandManager.execute(Commands.UPDATE_TEMP_WIN);


        const winsData = SpinModel.getCurrentWinsData();

        let promises: Promise<boolean>[] = [];
        SoundController.playSound("win_medium");
        winsData.forEach((win) => {

            promises.push(
                this.playWinCountersAnim(win)
            )
        });

        PromiseHelpers.combineParallel(promises)

        super.displayWin();
    }

    private playWinCountersAnim(winData): Promise<boolean> {

        return new Promise<boolean>(async (res) => {

            const possIndex = this.definePosition(winData.coordinates);
            let symbol = ReelGroup.instance.winSymbolsView.getAnimAtReelCell(winData.coordinates[possIndex].x-1, winData.coordinates[possIndex].y-1);
            let symbolOverlay = symbol.showTextOverlay(
                    5,
                    (winData.creditsWon / 100).toFixed(2)
                    // (BetModel.currency.symbol + (winData.creditsWon / 100).toFixed(2))
                ) as TextField;
            await this.showUp(symbolOverlay);
            if ((winData.coordinates[possIndex].y - 1) < 1) {
                await this.flyDown(symbolOverlay);
            } else {
                await this.flyUp(symbolOverlay);
            }
            symbolOverlay.destroy();
            res(true);
        });
    }

    private definePosition(coordinates: {x:number, y:number}[]): number {
        // these are the reels we want to show profit on by priority
        const reelsPriority: number[] = [3, 4, 2, 5, 1, 6];
        let reel: number = 0;

        for(let i = 0; i < reelsPriority.length; i++) {
            let winRow = 0;
            for(let j = 0; j < coordinates.length; j++) {
                // if the symbol "X" position matches with our desired position of the reels
                if (coordinates[j].x == reelsPriority[i]) {
                    reel = j;
                    winRow ++;
                    if (winRow < 3 &&
                        coordinates[j+1] &&
                        coordinates[j+1].x == reelsPriority[i]) {
                            continue;
                    } else {
                        break;
                    }
                }
            };
            if (reel != 0) {
                break;
            }
        };

        return reel;
    }

    private showUp(counter: TextField) {
        Zoom(counter, 0.1, 1, 0.2, 0, Ease.BackIn2);
        return PromiseHelpers.getFakePromise(0.3);
    }

    private flyUp(counter: TextField) {
        Tween.to(counter, 0.8, { y: counter.y - counter.height /2 });
        Zoom(counter, 1, 1, 0.8, 0);
        FadeOut(counter, 1.2, 0.3);
        return PromiseHelpers.getFakePromise(1);
    }
    private flyDown(counter: TextField) {
        Tween.to(counter, 0.8, { y: counter.y + counter.height /2 });
        Zoom(counter, 1, 1, 0.8, 0);
        FadeOut(counter, 1.2, 0.3);
        return PromiseHelpers.getFakePromise(1);
    }
}
